export const apiUrl = " https://api.itertravelapp.net";
export const aiApiUrl = "https://api-ai.itertravelapp.net";
export const s3Url = "https://iterai-bucket.s3.us-west-2.amazonaws.com";

export const imageUrl = (url) => {
  const result = url?.indexOf("http");
  const imageRenderUrl = result == -1 ? `${s3Url}/${url}` : url;
  return imageRenderUrl;
};
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
export const recordsLimit = 10;
